import { useSelector  } from "react-redux";
import { RootState } from "../store/index";
import { TaxCalculations } from '../model/tax_calculations';
import { Refund } from '../model/final_balance/refund';

// This object will be referenced often, so this is a convenience hook
// e.g. if you need to override balance to see different screens, edit this to new value
export const useTaxCalculations = (): TaxCalculations => {
  const { finalBalance } = useSelector((store: RootState) => store.payment);

  return finalBalance;
}

export const useRefund = (): Refund => {
  const { refund } = useSelector((store: RootState) => store.payment);

  return refund;
}
